
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBacklightHigh as ObiBacklightHighElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-backlight-high.js';
 
 
 

 
 export const ObiBacklightHigh = createComponent({
   react: React,
   tagName: 'obi-backlight-high',
   elementClass: ObiBacklightHighElement,
   events: {
     
   }
  });
 
 